import { BidTypeEnum, OldBidTypeEnum } from "../enums";

export const mapBidType: any = {
    [OldBidTypeEnum.LOWEST_COST_WITHOUT_CAP]: BidTypeEnum.LOWEST_COST_WITHOUT_CAP,
    [OldBidTypeEnum.LOWEST_COST_WITH_BID_CAP]: BidTypeEnum.LOWEST_COST_WITH_BID_CAP,
    [OldBidTypeEnum.COST_CAP]: BidTypeEnum.COST_CAP,
    [OldBidTypeEnum.LOWEST_COST_WITH_MIN_ROAS]: BidTypeEnum.LOWEST_COST_WITH_MIN_ROAS,
    [OldBidTypeEnum.TARGET_COST]: BidTypeEnum.TARGET_COST,
}